import * as React from "react";
const SvgFiRrAngleCircleUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-angle-circle-up_svg__a)">
      <path d="M12 24A12 12 0 1 0 0 12a12.013 12.013 0 0 0 12 12m0-22A10 10 0 1 1 2 12 10.01 10.01 0 0 1 12 2" />
      <path d="M12 8c.732 0 1.44.267 1.988.752.327.291.636.574.84.777l2.873 2.824a1 1 0 1 1-1.4 1.426l-2.88-2.829a21 21 0 0 0-.76-.7 1 1 0 0 0-1.322 0c-.29.258-.57.512-.753.693L7.7 13.779a1 1 0 0 1-1.4-1.426l2.878-2.829c.2-.2.507-.48.833-.769A3 3 0 0 1 12.002 8" />
    </g>
    <defs>
      <clipPath id="fi-rr-angle-circle-up_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAngleCircleUp;
